import { useState } from 'react';
import { useTheme } from '../../contexts/ThemeProvider';
import { Button } from '../ui/Button';
import { Input } from '../ui/Input';

export function ThemeManagement() {
    const { availableThemes, setTheme, theme: currentTheme } = useTheme();
    const [isCreating, setIsCreating] = useState(false);

    // Mock state for new theme form
    const [newThemeName, setNewThemeName] = useState('');
    const [primaryColor, setPrimaryColor] = useState('#000000');
    const [secondaryColor, setSecondaryColor] = useState('#000000');
    const [bgColor, setBgColor] = useState('#ffffff');

    const handleCreate = (e: React.FormEvent) => {
        e.preventDefault();
        alert('Theme creation logic would go here (saving to Firestore).');
        setIsCreating(false);
    };

    return (
        <div className="bg-white p-6 rounded-xl border-2 border-zinc-200">
            <div className="flex justify-between items-center mb-6">
                <h2 className="text-2xl font-bold font-hand">Themes</h2>
                <Button
                    variant="primary"
                    className="text-sm py-1"
                    onClick={() => setIsCreating(!isCreating)}
                >
                    {isCreating ? 'Cancel' : 'Create New Theme'}
                </Button>
            </div>

            {isCreating && (
                <form onSubmit={handleCreate} className="mb-8 bg-zinc-50 p-4 rounded-xl border-2 border-dashed border-zinc-300">
                    <h3 className="font-bold mb-4">New Theme</h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                        <div>
                            <label className="block text-sm font-semibold mb-1">Theme Name</label>
                            <Input value={newThemeName} onChange={e => setNewThemeName(e.target.value)} placeholder="e.g. Midnight Wave" />
                        </div>
                        <div>
                            <label className="block text-sm font-semibold mb-1">Background Color</label>
                            <div className="flex gap-2">
                                <input type="color" value={bgColor} onChange={e => setBgColor(e.target.value)} className="h-10 w-10 border-2 border-zinc-300 rounded" />
                                <Input value={bgColor} onChange={e => setBgColor(e.target.value)} />
                            </div>
                        </div>
                        <div>
                            <label className="block text-sm font-semibold mb-1">Primary Color</label>
                            <div className="flex gap-2">
                                <input type="color" value={primaryColor} onChange={e => setPrimaryColor(e.target.value)} className="h-10 w-10 border-2 border-zinc-300 rounded" />
                                <Input value={primaryColor} onChange={e => setPrimaryColor(e.target.value)} />
                            </div>
                        </div>
                        <div>
                            <label className="block text-sm font-semibold mb-1">Secondary Color</label>
                            <div className="flex gap-2">
                                <input type="color" value={secondaryColor} onChange={e => setSecondaryColor(e.target.value)} className="h-10 w-10 border-2 border-zinc-300 rounded" />
                                <Input value={secondaryColor} onChange={e => setSecondaryColor(e.target.value)} />
                            </div>
                        </div>
                    </div>
                    <Button type="submit" variant="primary">Save Theme</Button>
                </form>
            )}

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {availableThemes.map((theme) => (
                    <div
                        key={theme.id}
                        className={`
              relative p-4 rounded-xl border-3 cursor-pointer transition-transform hover:-translate-y-1
              ${currentTheme.id === theme.id ? 'border-primary shadow-pop' : 'border-zinc-200'}
            `}
                        style={{ backgroundColor: theme.backgroundColor }}
                        onClick={() => setTheme(theme.id)}
                    >
                        {currentTheme.id === theme.id && (
                            <div className="absolute top-2 right-2 bg-primary text-white text-xs font-bold px-2 py-1 rounded-full">
                                ACTIVE
                            </div>
                        )}

                        <h3 className="font-bold text-lg mb-3" style={{ color: '#18181b' }}>{theme.name}</h3>

                        <div className="flex gap-3">
                            <div className="flex-1 h-12 rounded-lg border-2 border-black/10 flex items-center justify-center text-xs font-bold text-white shadow-sm" style={{ backgroundColor: theme.primaryColor }}>
                                Primary
                            </div>
                            <div className="flex-1 h-12 rounded-lg border-2 border-black/10 flex items-center justify-center text-xs font-bold text-white shadow-sm" style={{ backgroundColor: theme.secondaryColor }}>
                                Secondary
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
